import React, { useState } from "react";
import "./Faq.css";

const faqs = [
    {
        question: "Which internet service provider is best in Achampet for a new connection?",
        answer:
            "Ritu Broad Band offers reliable high-speed internet with speeds up to 200 Mbps, affordable pricing starting at ₹499, and excellent customer service. We provide fiber-optic connectivity with Digital TV and OTT platforms included."
    },
    {
        question: "Which WiFi connection is best in Achampet for families?",
        answer:
            "For families, we recommend our 50 Mbps or higher plans which provide sufficient bandwidth for multiple devices, streaming, online gaming, and work from home requirements. These plans also include access to 29 OTT platforms including Netflix and 300+ Live TV channels."
    },
    {
        question: "Which plan is suitable for work from home in Achampet?",
        answer:
            "Our 50 Mbps and above plans are ideal for work from home as they offer reliable speeds, ensuring smooth video conferencing, file uploads, and uninterrupted connectivity throughout the day."
    },
    {
        question: "Is Ritu Broad Band reliable in Achampet?",
        answer:
            "Yes, Ritu Broad Band is highly reliable with fiber-optic connectivity, minimal downtime, and dedicated customer support. Contact us at 7702935830 or 8500168970 for any assistance."
    },
    {
        question: "What is the minimum bandwidth required for home internet in Achampet?",
        answer:
            "For basic browsing and streaming, 30 Mbps (₹499) is sufficient. For multiple users and devices, we recommend at least 50 Mbps. For heavy usage, gaming, and 4K streaming, 75 Mbps or higher is ideal."
    }
];

function Faq() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <h2 className="section-title">FAQs</h2>

            <div className="faq-container">
                {faqs.map((faq, index) => (
                    <div className="faq-item" key={index}>
                        <div className="faq-question" onClick={() => toggleFAQ(index)}>
                            <span>{faq.question}</span>
                            <span className={`faq-icon ${activeIndex === index ? "active" : ""}`}>
                                ▼
                            </span>
                        </div>

                        {/* ALWAYS render, just toggle class */}
                        <div className={`faq-answer ${activeIndex === index ? "active" : ""}`}>
                            <p>{faq.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Faq;
